import TaskStatus from './task-status.enum';

export default class Task {
  id: string;

  status: TaskStatus;

  startedDate: Date;

  finishedDate: Date;

  payload: any;

  constructor(obj: any) {
    this.id = obj.id;
    this.status = obj.status;
    this.startedDate = obj.startDate;
    this.finishedDate = obj.finishedDate;
    this.payload = obj.payload ? JSON.parse(obj.payload) : {};
  }

  get isFinished() {
    return TaskStatus.ERROR === this.status || TaskStatus.SUCCESS === this.status;
  }

  resolve(): Promise<Task> {
    if (TaskStatus.ERROR) {
      return Promise.reject(this.payload);
    }
    return Promise.resolve(this);
  }
}
